module.exports = __webpack_public_path__ + "img/more.6560bb7a.png";